import Modal from "components/global/modal";
import { Link } from "react-router-dom";
import { FeaturedIcon,BgPremium } from "constants/images";
import { CiClock2 } from "react-icons/ci";
import CheckCircleIconSVG from "assets/svg/check-circle-icon";
import { SubscriptionContext } from "context/subscription";
import { useContext } from "react";
import Button from "components/button/button";
import CardIconSVG from "assets/svg/card-icon-svg";
import LoadingIndicator from "assets/svg/loading-indicator";
import PaypalIconSVG from "assets/svg/paypal-icon-svg";
import { STRIPE_AUD_PREMIUM_LIFETIME, PAYPAL_AUD_PREMIUM_LIFETIME } from "configs/subscription";
import { BASE_URL } from "configs/api";
import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";

const PremiumModal = ({
    hide,
})=>{
  const { http } = global.services;
  const {setPopUpPrem,setPremiumFooter,viewPremiumFooter} = useContext(SubscriptionContext);
  
    const benifits = [
        "Unlimited milestone buttons (links, PDFs, images, audio, video)",
        "Messaging (send & receive)",
        "Analytics: profile & button views",
        "Bio media: photos & videos",
        "Verification: blue tick (ID required)",
        "Hero button",
        "Mutual connections",
        "Up to 4 sub-profiles (groups, teams, characters)",
        "Advanced profile management",
    ];

  const [processing, setProcessing] = useState(false);

    const stripeCheckout = async () => {
      // Use existing public/subscribes endpoint but pass a lifetime plan id
      let userData = JSON.parse(localStorage.getItem('user_data')) || null;
      try {
        setProcessing(true);
        const { http } = global.services;
        const { data } = await http.post("public/signup-subscribes", {
          plan: "Premium Lifetime",
          price_id: STRIPE_AUD_PREMIUM_LIFETIME,
          currency: "aud",
          price_id: STRIPE_AUD_PREMIUM_LIFETIME,
          success_url: `${BASE_URL}/sign-up?verify=${encodeURIComponent(userData.user.email || "")}`,
          cancel_url: `${BASE_URL}/sign-up?chooseplan=1`,
          email: userData.user.email
        });
        window.location.href = data.url;
      } catch (err) {
        console.log(err);
        toast.error(err?.data?.message || err.message);
      } finally {
        setProcessing(false);
      }
    };

    const paypalCheckout = async () => {
      try {
        let userData = JSON.parse(localStorage.getItem('user_data')) || null;
        setProcessing(true);
        const { http } = global.services;
        const { data } = await http.post("public/paypal/signup-subscribes", {
          plan: "Premium Lifetime",
          plan_id: PAYPAL_AUD_PREMIUM_LIFETIME,
          currency: "aud",
          email: userData.user.email,
          success_url: `${BASE_URL}/sign-up?verify=${encodeURIComponent(userData.user.email || "")}`,
          cancel_url: `${BASE_URL}/sign-up?chooseplan=1`,
        });
        window.location.href = data.url;
      } catch (err) {
        console.log(err);
        toast.error(err?.data?.message || err.message);
      } finally {
        setProcessing(false);
      }
    };

    const closePremium = async()=>{
        let userData = JSON.parse(localStorage.getItem('user_data')) || null;
        setPremiumFooter(true)
        hide()
        if(userData){
           try{
            await http.post(`public/profiles/${userData.profile.id}/close-premium`);
            setPopUpPrem(false)
           }catch(e){
            console.error(e)
           }
        }
    }
    return (
        <Modal
              width="w-full md:w-16/20 2md:w-12/20 3md:w-9/20 1xl:w-8/20"
              contentClassName="rounded-lg overflow-auto custom-scroll"
              wrapperClassName="overflow-visible"
              footerClass="border-t border-gray">
                <div className="my-6 mx-2 md:mx-12">
                    <div className="flex items-center flex-col">
                        <div className="flex justify-between items-center w-full">
                            <h1 className="font-bold text-lg md:text-2xl flex w-full item-center justify-center">Upgrade to Premium Account</h1>
                            <div><span className="close" onClick={closePremium}></span></div>
                        </div>
                        <p className="text-[.8rem] md:text-[1rem] text-center">Unlock the full experience with a Premium Milestones account. Here's what you get:</p>
                    </div>
                    <div className={`text-white rounded-xl px-12 mt-2 md:mt-8`}
                            style={{ backgroundImage: `url(${BgPremium})`,
                            backgroundSize:'cover',
                            backgroundPosition:'center center',
                            backgroundRepeat: 'no-repeat'
                         }}
                    >
                        <div className="flex w-full justify-center flex-col items-center pt-8 gap-4">
                            <img src={FeaturedIcon} alt="fIcon"/>
                            <h3 className="font-bold text-xl">Premium Account</h3>
                            <h1 className="text-2xl font-bold">A$67<span className="text-[.8rem] font-bold">/Lifetime</span> <span className="text-lg line-through font-normal text-darkGray">$249</span></h1>
                            <div className="flex gap-2 justify-center px-8 py-3 rounded-md text-[0.9rem] bg-lightBlack/40 items-center">
                                <CiClock2 className="text-2xl md:text-lg"/>
                                <div className="text-[.7rem] md:text-[.8rem] text-center">Limited Time Only</div>
                            </div>
                        </div>
                        <div>
                            <ul className="py-6">
                                <div className="text-lg md:text-xl mb-4 text-center font-semibold">Everything Included in the Free Account Plus:</div>
                                {
                                    benifits.map((item)=>
                                    (
                                        <li key={item} className="flex gap-4 items-center pb-2 md:pb-3">
                                            <CheckCircleIconSVG className="text-4xl md:text-2xl"/>
                                            <p className="text-[.8rem] md:text-[1.1rem]">{item}</p>
                                        </li>
                                        )
                                    )
                                }
                            </ul>
                        </div>
                        <div className="w-full flex flex-col xl:flex-row gap-4 pb-8 md:pb-12">
                            <Button
                                buttonName="Paypal Checkout"
                                buttonClass="w-full bg-[#f7be3b] hover:brightness-95 p-4"
                                buttonTextClass="flex items-center justify-center gap-2 text-sm font-semibold text-neutral-800"
                                onClick={paypalCheckout}
                                disabled={processing}
                                icon={processing ? <LoadingIndicator className="w-4 h-4" /> : <PaypalIconSVG className="w-6 h-6" />}
                                iconPosition="left"
                            />
                            <Button
                                buttonName="Use Debit or Credit Card"
                                buttonClass="w-full bg-[#0d6ed1] hover:bg-[#0b58a7] p-4"
                                buttonTextClass="flex items-center justify-center gap-2 text-white text-sm font-semibold"
                                onClick={stripeCheckout}
                                disabled={processing}
                                icon={processing ? <LoadingIndicator className="w-4 h-4" /> : <CardIconSVG />}
                                iconPosition="left"
                            />
                        </div>
                    </div>
                </div>
              </Modal>
    )
}

export default PremiumModal;